import Button from "react-bootstrap/Button";
import { Image } from "react-bootstrap";

import { Lightbox } from "components/Lightbox";
import { Loading } from "components/Loading";

// Jediný zdroj otázky — jde do `ariaLabel` i do viditelného nadpisu, ať se ty dva
// texty nemůžou rozejít. [TD-344]
const QUESTION = "Chceš otázku vyřadit z tréninku?";

interface Props {
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

// AIDEV-NOTE: `ariaLabel`, ne `bodyTitleId` — otázka žijící v `bodyTitleId` by za `isLoading`
// zmizela ze stromu (vykresluje se jen `<Loading />`) a `aria-labelledby` by mířilo na
// neexistující id. Text duplikuje viditelnou otázku, jen se nevykresluje. [TD-344]
export const BlacklistInConfirmModal: React.FC<Props> = ({ isLoading, onClose, onConfirm }) => (
  <Lightbox show onHide={onClose} ariaLabel={QUESTION}>
    {isLoading ? (
      <Loading />
    ) : (
      <>
        <div className="mb-8px text-center">
          <Image src="/images/120-blacklist-in.svg" />
        </div>
        {/* fs-18 drží dosavadní vzhled h3 — nadpisy se sjednocují na sémantické h2. [TD-344] */}
        <h2 className="text-center mb-20px fs-18">{QUESTION}</h2>
        <p className="text-center mb-20px">
          Najdeš ji potom sekci „Vyřazené úlohy“, kdykoli ji můžeš do tréninku vrátit. 🙂
        </p>
        <Button variant="outline-primary" className="w-100" onClick={onConfirm}>
          Ano, vyřadit z tréninku
        </Button>
        <Button variant="link" className="w-100" onClick={onClose}>
          Ne, ponechat v tréninku
        </Button>
      </>
    )}
  </Lightbox>
);
